const config = require('./' + process.env.REACT_APP_PROJECT_NAME + '-edit-settings-config');
export default config;
